module.exports = __webpack_public_path__ + "img/sinBarreras222.b9f3caed.jpg";